// project import
import adminMenuItems from './admin';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = adminMenuItems;

export default menuItems;
